<template>
    <div>
        <button type="button" class="tw-btn tw-btn--secondary"
            v-bind:class="{
                'tw-btn tw-btn--secondary tw-header__action' : buttonPosition === 'header-button-lg' || buttonPosition === 'header-button-sm',
                'tw-btn tw-btn--secondary tw-btn tw-btn--secondary tw-btn--lg tw-btn--block tw-responsive__xxs--block tw-responsive__xs--block' : buttonPosition === 'header-button-block',
                'tw-btn tw-btn--secondary tw-btn--lg tw-btn--block tw-responsive__xxs--block tw-responsive__xs--block' : buttonPosition === 'tickets-button',
                'tw-btn tw-btn--secondary tw-btn--lg tw-btn--block tw-responsive__xxs--block tw-responsive__xs--block tw-btn--stretch' : buttonPosition === 'tickets-button-top',
                'tw-btn--fixed' : toggleSticky
            }"
            :disabled="!selectedTotal > 0 || cartManager.sendingToCheckout"
            v-on:click='goToCheckoutStage()'>
                {{ selectedTotal && selectedCost === 0 ? 'Get Tickets' : 'Buy Now' }}
                <img src="https://static.designmynight.com/images/payment-types-mini.png" alt="Debit and credit cards accepted" width="60" v-bind:class="{
                 'tw-responsive__xxs--hide tw-responsive__xs--hide tw-responsive__sm--hide' : buttonPosition === 'header-button-sm' || buttonPosition === 'header-button-block'
                }"/>

                <font-awesome-icon v-if="cartManager.sendingToCheckout" icon="spinner" />
        </button>
    </div>
</template>

<script lang="ts">
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import CartManager from '../../../services/CartManager';
    import TicketWidgetComponent from '../../TicketWidgetComponent';

    //fontawesome
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faSpinner } from '@fortawesome/free-solid-svg-icons';

    library.add(faSpinner);

    @Component({
        components: {
            FontAwesomeIcon
        }
    })


    export default class BuyNowButton extends TicketWidgetComponent {

        @Prop() public buttonPosition!: string;
        @Prop() public toggleSticky!: boolean;

        selectedTotal: number = 0;
        selectedCost: number = 0;
        $gtag: any;
       window: any;

        /**
        * @desc when mounted, grab the stages and initiulize an event listener
        */
        mounted() {
            this.$root.$on('updateCart', () => {
                this.cartUpdated();
            })
        }

        /**
        * @desc listener is set up in mounted(), is called when the cart updates
        */
        cartUpdated() {
            this.selectedTotal = this.cartManager.getTotalQuantitySelected();
            this.selectedCost = this.cartManager.getTotalCostOfSelected();
        }

        /**
        * @desc sends the user to the checkout
        */
        goToCheckoutStage() {
            if (window && window.dataLayer) {
                const occurrenceMoment = this.selectedOccurrence.occurrenceMoment;
                const eventDate = occurrenceMoment.format('YYYY-MM-DD');
                const dmnReferenceId = this.cartManager.purchaseId || null;

                const items = this.cartManager.getItems().map((ticket) => {
                    const ticketType = this.selectedEvent.getTicketType(ticket.sub_type);

                    return {
                        item_id: `${ticket.item_id}_${ticket.sub_type}`,
                        item_name: ticketType.name,
                        quantity: ticket.quantity,
                        item_brand: this.cartManager.event.title,
                        price: ticketType.price,
                        item_category: "Access Tonic",
                        item_list_id: `${this.selectedEvent._id}_${occurrenceMoment.format('YYYYMMDD')}`,
                        item_list_name: `${this.selectedEvent.title} (${eventDate})`,
                    }
                });

                window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
                window.dataLayer.push({
                    event: 'add_to_cart',
                    event_date: eventDate,
                    dmn_reference_id: dmnReferenceId,
                    ecommerce : {
                        value: this.cartManager.getTotalCostOfSelected(),
                        currency: this.selectedEvent.currency,
                        items,
                    },
                });
            }
            this.showCheckoutError = false;
            this.dmnOptions.widgetMode === 'list-view' ? this.$root.$emit('buyNow') : this.$router.push({ path: 'checkout' });
        };
    }
</script>
